import React, { Component } from "react"
import * as api from "../../api"
import { SelectField, MenuItem } from "material-ui"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import { IJobStatus, IJobSubStatus, EJobType } from "../../models"
import ClearIcon from "material-ui/svg-icons/content/clear"
import { EnumValues } from "enum-values"

interface IProps {
    jobType?: EJobType | string
    statusId?: string
    subStatusId?: string
    onStatusChange: (data: IState) => any
}
interface IState {
    jobStatuses: IJobStatus[]
    status: IJobStatus
    jobType: EJobType | string
    subStatus: IJobSubStatus
}

export default class JobStatusSelection extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            jobStatuses: [],
            status: null,
            jobType: props.jobType === null ? strings.All : `${props.jobType}`,
            subStatus: null
        }
    }

    componentDidMount() {
        this.getJobStatuses()
    }

    getJobStatuses() {
        AccountStore.getHREnabled() &&
            api.getJobStatuses(AccountStore.getCurrentAccount().Id).then((res) => {
                const jobStatuses: IJobStatus[] = res.data
                const status: IJobStatus = this.props.statusId ? jobStatuses.find(i => i.Id === this.props.statusId) : null
                const subStatus: IJobSubStatus = this.props.subStatusId && status && status.SubStatuses ?
                    status.SubStatuses.find(i => i.Id === this.props.subStatusId) : null
                this.setState({ jobStatuses, status, subStatus })
            })
    }

    render() {
        return (
            <div>
                {AccountStore.getHREnabled() && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        {AccountStore.getJobsEnabled() && AccountStore.getCRMEnabled() && (
                            <SelectField
                                data-intercom-target={"Jobs-Filter-Select-Contract"}
                                floatingLabelText={strings.Contract}
                                onChange={(event, key, status) =>
                                    this.setState(
                                        { jobType: status },
                                        () => this.props.onStatusChange({ ...this.state, jobType: this.state.jobType === strings.All ? null : this.state.jobType })
                                    )
                                }
                                style={{ flex: 1, marginRight: 20 }}
                                value={this.state.jobType || ""}
                            >
                                <MenuItem value={strings.All} primaryText={strings.All} />
                                {EnumValues.getNamesAndValues(EJobType).map((item, i) => {
                                    return <MenuItem key={i} value={`${item.value}`} primaryText={item.name} />
                                })}
                            </SelectField>
                        )}
                        <SelectField
                            data-intercom-target={"menu-Jobs-Filter-Select-Status"}
                            floatingLabelText={strings.Status}
                            value={this.state.status || ""}
                            onChange={(event, key, status) => this.setState({ status }, () => this.props.onStatusChange(this.state))}
                            style={{ flex: 1, marginRight: 20 }}
                        >
                            {this.state.jobStatuses.filter(i => i.Active).map((item, index) => (
                                <MenuItem style={{ whiteSpace: "pre-wrap" }} key={index} value={item} primaryText={item.Name} />
                            ))}
                        </SelectField>
                        <SelectField
                            data-intercom-target={"menu-Jobs-Filter-Select-SubStatus"}
                            floatingLabelText={strings.Substatus}
                            value={this.state.subStatus}
                            onChange={(event, key, subStatus) => this.setState({ subStatus }, () => this.props.onStatusChange(this.state))}
                            disabled={this.state.status === null || this.state.status === undefined ? true : false}
                            style={{ flex: 1 }}
                        >
                            {this.state.status && this.state.status.SubStatuses.filter(i => i.Active).map((item, index) => <MenuItem style={{ whiteSpace: "pre-wrap" }} key={index} value={item} primaryText={item.Name} />)}
                        </SelectField>
                        {(this.state.status !== null || this.state.subStatus !== null) && (
                            <ClearIcon
                                data-intercom-target={"menu-Jobs-Filter-Btn-ClearStatusFilter"}
                                style={{ marginLeft: 20, cursor: "pointer" }}
                                onClick={() => this.setState({ status: null, subStatus: null, jobType: strings.All }, () => this.props.onStatusChange(this.state))}
                            />
                        )}
                    </div>
                )}
            </div>
        )
    }
}
